/* eslint-env browser */
import tokens from '../theme/tokens';
import regularFontUrl from '../assets/fonts/FormaDJRUI-Regular.ttf';
import mediumFontUrl from '../assets/fonts/FormaDJRUI-Medium.ttf';
import logoUrl from '../assets/branding/hp-logo-512.png';

export const PDF_FONT = tokens.fonts.pdfFamily;

export function pdfColor(name) {
    const hex = tokens.colors[name];
    if (!/^#[0-9a-fA-F]{6}$/.test(hex)) {
        throw new Error(`Colour token "${name}" is not a #RRGGBB value, so it cannot be used in a PDF`);
    }
    return [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
}

const cache = {};

function toBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
    }
    return btoa(binary);
}

function loadBase64(url) {
    if (!cache[url]) {
        cache[url] = fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Could not load ${url} (${response.status})`);
                }
                return response.arrayBuffer();
            })
            .then(toBase64);
    }
    return cache[url];
}

export function registerPdfFonts(doc) {
    return Promise.all([loadBase64(regularFontUrl), loadBase64(mediumFontUrl)]).then(([regular, medium]) => {
        doc.addFileToVFS('FormaDJRUI-Regular.ttf', regular);
        doc.addFont('FormaDJRUI-Regular.ttf', PDF_FONT, 'normal');
        doc.addFileToVFS('FormaDJRUI-Medium.ttf', medium);
        doc.addFont('FormaDJRUI-Medium.ttf', PDF_FONT, 'bold');
    });
}

const logoCache = {};

export function loadLogoDataUrl(backgroundColorName) {
    if (!logoCache[backgroundColorName]) {
        pdfColor(backgroundColorName);
        logoCache[backgroundColorName] = new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                const context = canvas.getContext('2d');
                context.fillStyle = tokens.colors[backgroundColorName];
                context.fillRect(0, 0, canvas.width, canvas.height);
                context.drawImage(image, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            image.onerror = () => reject(new Error(`Could not load ${logoUrl}`));
            image.src = logoUrl;
        });
    }
    return logoCache[backgroundColorName];
}
